/* TWRD variant-galleri.
   Filtrerer produktets medier paa farve, laest fra alt-teksten i Shopify Admin.
   Alt-tekst = styringen. Ingen tema-aendring naar der kommer nye billeder.

   Regler:
   - Et medie med et farve-token vises kun for den farve.
   - Et medie uden farve-token vises altid.
   - Giver filteret nul billeder, vises alle (fallback).
   - Style-option (FRONT PRINT / BACK PRINT): medier maerket med en anden
     edition skjules. Intet sorteres.

   RAEKKEFOELGE (data-twrd-vg-order paa <media-gallery>):
   - manual : STANDARD. Shopifys medie-raekkefoelge bruges praecis som den er
              trukket i Admin, inden for farve og Style. Gruppens foerste
              billede aabner siden. Variantens billede ignoreres her (det
              bruges stadig i kurv, soegning, kort og i auto).
   - auto   : tilvalg. Produktet har tagget "gallery-auto", eller tema-
              indstillingen "Auto-order product images" er slaaet til.
              Sorteres efter billedtype fra alt-teksten, se rankOf().
              Variantens billede staar foerst.
   Pin (begge tilstande): slutter alt-teksten med " #2", laases billedet til
   plads 2. Liquid fjerner markoeren fra alt og sender den som data-twrd-pin.
   Dokumentation: docs/galleri-raekkefoelge-2026-09-30.md

   Galleriet bygges op fra et rent HTML-snapshot ved hvert skift, og noden
   udskiftes. Saa kalder temaet selv connectedCallback igen, og baade Swiper
   (mobil-karrusel) og PhotoSwipe (zoom) bliver bygget paa de synlige billeder.
   Alt er scopet til .twrd-vg. */
(function () {
  'use strict';

  var SELECTOR = 'media-gallery.twrd-vg';

  /* Tokens er "key:value" adskilt af mellemrum, men en value kan selv have
     mellemrum ("colour:smoky black"). Split derfor foran naeste key, ikke paa
     hvert mellemrum. */
  function tokens(el) {
    var raw = el.getAttribute('data-twrd-tags') || '';
    var out = [];
    var re = /(colour|edition|view):(.*?)(?=\s+(?:colour|edition|view):|$)/g;
    var m;
    while ((m = re.exec(raw)) !== null) out.push(m[1] + ':' + m[2].trim());
    return out;
  }

  function matches(el, colour) {
    var list = tokens(el);
    var colours = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].indexOf('colour:') === 0) colours.push(list[i].slice(7));
    }
    if (!colours.length) return true;
    return colours.indexOf(colour) !== -1;
  }

  function editionOf(el) {
    var list = tokens(el);
    for (var i = 0; i < list.length; i++) {
      if (list[i].indexOf('edition:') === 0) return list[i].slice(8);
    }
    return '';
  }

  function viewOf(el) {
    var list = tokens(el);
    for (var i = 0; i < list.length; i++) {
      if (list[i].indexOf('view:') === 0) return list[i].slice(5);
    }
    return '';
  }

  /* Print-optionen hedder "Style" paa nogle produkter og "Print Position" paa
     andre. Begge navne styrer det samme front/back-valg. Kun ét sted. */
  function isStyleName(name) {
    var lower = String(name || '').toLowerCase();
    return lower.indexOf('style') !== -1 || lower.indexOf('print') !== -1;
  }

  /* Valgt Style-option, oversat til "front" / "back" / "". */
  function selectedView(ctx) {
    var inputs = ctx.scope.querySelectorAll('input[type="radio"]:checked, select');
    for (var i = 0; i < inputs.length; i++) {
      var name = (inputs[i].getAttribute('name') || '').toLowerCase();
      if (!isStyleName(name)) continue;
      var value = String(inputs[i].value || '').toLowerCase();
      if (value.indexOf('back') !== -1) return 'back';
      if (value.indexOf('front') !== -1) return 'front';
    }
    return '';
  }

  /* Medie-id'et paa et slide. Attributten sidder paa barnet, ikke paa
     [data-slide] selv. */
  function mediaIdOf(slide) {
    var el = slide.querySelector('[data-media-id]');
    return el ? String(el.getAttribute('data-media-id') || '') : '';
  }

  /* "variantId:mediaId variantId:mediaId ..." fra product-gallery.liquid. */
  function featuredMap(gallery) {
    var raw = clean(gallery.getAttribute('data-twrd-vg-featured'));
    var map = {};
    if (!raw) return map;
    var parts = raw.split(/\s+/);
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i].split(':');
      if (pair.length === 2 && pair[0] && pair[1]) map[pair[0]] = pair[1];
    }
    return map;
  }

  /* Featured media for den variant der er valgt lige nu. Variant-id'et staar
     i produktformularens skjulte input, som temaet selv opdaterer. */
  function featuredMediaId(ctx) {
    var input = ctx.scope.querySelector('input[name="id"], select[name="id"]');
    var id = input ? String(input.value || '').trim() : '';
    return (id && ctx.featured[id]) || '';
  }

  function selectedColour(ctx) {
    var value = '';
    var inputs = ctx.scope.querySelectorAll('input[type="radio"]:checked, select');
    for (var i = 0; i < inputs.length && !value; i++) {
      var name = (inputs[i].getAttribute('name') || '').toLowerCase();
      if (name === ctx.optName.toLowerCase()) value = inputs[i].value;
    }
    value = String(value || '').trim().toLowerCase();
    return ctx.colours.indexOf(value) !== -1 ? value : ctx.colours[0];
  }

  /* ---------- Raekkefoelge: rene funktioner, ingen DOM ---------- */

  var RANK_HERO = 0;
  var RANK_FULL = 1;
  var RANK_POSE = 2;
  var RANK_OPPOSITE = 3;
  var RANK_PRINT_CLOSEUP = 4;
  var RANK_DETAIL = 5;
  var TILE_NAMES = ['hero', 'full', 'pose', 'opposite', 'closeup', 'detail'];
  /* Fra og med denne rang maa en flise ikke vaere den store i mosaikken. */
  var RANK_NO_WIDE = RANK_PRINT_CLOSEUP;
  /* Koen-skift (mand/kvinde) bruges kun paa model-billeder, ikke paa udsnit. */
  var RANK_ALTERNATE_MAX = RANK_OPPOSITE;
  /* Et alt i det laaste format har mindst tre komma-segmenter. */
  var MIN_STRUCTURED_SEGMENTS = 3;
  var EAGER_TILES = 2;
  var MAX_PIN = 99;

  var DETAIL_WORDS = ['detail', 'flat lay', 'flatlay', 'stitching', 'waistband', 'drawstring waist', 'closeup', 'collar close up', 'cuff'];
  var CLOSE_WORDS = ['close up', 'close-up'];
  var HERO_WORDS = ['half figure', 'thigh up', 'three quarter', 'hand on collar', 'waist up', 'hand on hip', 'hands on hips'];
  var FULL_WORDS = ['walk', 'standing'];

  function hasAny(text, words) {
    for (var i = 0; i < words.length; i++) {
      if (text.indexOf(words[i]) !== -1) return true;
    }
    return false;
  }

  function isStructured(alt) {
    return String(alt || '').split(',').length >= MIN_STRUCTURED_SEGMENTS;
  }

  function genderOf(alt) {
    if (!isStructured(alt)) return '';
    if (/\bwoman\b/.test(alt)) return 'w';
    if (/\bman\b/.test(alt)) return 'm';
    return '';
  }

  /* Billedtype fra alt-teksten (lowercase). Lav rang = tidligt i galleriet.
     photoView = hvad fotoet viser (front/back), view = den valgte Style. */
  function rankOf(alt, photoView, view) {
    var text = String(alt || '').toLowerCase();
    if (hasAny(text, DETAIL_WORDS)) return RANK_DETAIL;
    /* Generiske alt-tekster kender vi ikke typen paa: neutral, Shopify-raekkefoelge. */
    if (!isStructured(text)) return RANK_POSE;

    var opposite = !!view && !!photoView && photoView !== view;
    var segments = text.split(',');
    var last = segments[segments.length - 1].trim();
    var full = text.indexOf('full body') !== -1;
    var hero = hasAny(text, HERO_WORDS);
    var wide = hasAny(text, FULL_WORDS);

    var close = hasAny(text, CLOSE_WORDS) || (!full && !hero && !wide && /\bchest$/.test(last));
    if (close) return opposite ? RANK_DETAIL : RANK_PRINT_CLOSEUP;
    if (opposite) return RANK_OPPOSITE;
    if (full) return RANK_FULL;
    if (hero) return RANK_HERO;
    if (wide) return RANK_FULL;
    return RANK_POSE;
  }

  /* Skifter mellem mand og kvinde inden for een rang. Billeder uden kendt
     koen bliver staaende paa deres plads. Shopify-raekkefoelgen holdes inden
     for hvert koen. */
  function alternate(bucket, prevGender) {
    var men = bucket.filter(function (x) { return x.gender === 'm'; });
    var women = bucket.filter(function (x) { return x.gender === 'w'; });
    if (!men.length || !women.length) return { list: bucket, last: lastGender(bucket, prevGender) };
    var mi = 0;
    var wi = 0;
    var last = prevGender;
    var list = bucket.map(function (x) {
      if (!x.gender) return x;
      var want = last === 'm' ? 'w' : last === 'w' ? 'm' : x.gender;
      if (want === 'm' && mi >= men.length) want = 'w';
      if (want === 'w' && wi >= women.length) want = 'm';
      var pick = want === 'm' ? men[mi++] : women[wi++];
      last = pick.gender;
      return pick;
    });
    return { list: list, last: last };
  }

  function lastGender(list, fallback) {
    for (var i = list.length - 1; i >= 0; i--) {
      if (list[i].gender) return list[i].gender;
    }
    return fallback;
  }

  /* items: [{ index, alt, view, mediaId, pin }] i Shopify-raekkefoelge.
     Returnerer en ny liste, sorteret efter rang, stabil ved lighed. */
  function sortByRank(items, view, seedGender) {
    var ranked = items.map(function (item) {
      return { item: item, rank: rankOf(item.alt, item.view, view), gender: genderOf(item.alt) };
    });
    var out = [];
    var prev = seedGender || '';
    for (var rank = RANK_HERO; rank <= RANK_DETAIL; rank++) {
      var bucket = ranked.filter(function (x) { return x.rank === rank; });
      if (rank <= RANK_ALTERNATE_MAX) {
        var mixed = alternate(bucket, prev);
        bucket = mixed.list;
        prev = mixed.last;
      }
      out = out.concat(bucket.map(function (x) { return x.item; }));
    }
    return out;
  }

  /* Laegger pinnede billeder paa deres plads (1-baseret). lead er det billede
     der allerede ligger paa plads 1 (variantens billede), eller null.
     Er pladsen optaget, bruges naeste ledige plads. */
  function placePins(lead, pinned, rest) {
    var total = (lead ? 1 : 0) + pinned.length + rest.length;
    var slots = [];
    for (var s = 0; s < total; s++) slots.push(null);
    if (lead) slots[0] = lead;

    var sorted = pinned.slice().sort(function (a, b) {
      return a.pin - b.pin || a.index - b.index;
    });
    sorted.forEach(function (item) {
      var want = Math.min(Math.max(item.pin, 1), total) - 1;
      var at = -1;
      for (var up = want; up < total && at === -1; up++) if (!slots[up]) at = up;
      for (var down = want - 1; down >= 0 && at === -1; down--) if (!slots[down]) at = down;
      if (at !== -1) slots[at] = item;
    });

    var next = 0;
    return slots.map(function (slot) {
      return slot || rest[next++];
    });
  }

  /* Hele auto-raekkefoelgen. view = valgt Style ('front' / 'back' / ''). */
  function autoOrder(items, view, featuredId) {
    var lead = null;
    if (featuredId) {
      lead = items.filter(function (x) { return x.mediaId === featuredId; })[0] || null;
    }
    /* Uden variant-billede og uden Style: Shopifys foerste billede bliver
       staaende forrest. Saa bliver et produkt med generiske alt-tekster ikke
       aendret. */
    if (!lead && !view && items.length) lead = items[0];

    var others = items.filter(function (x) { return x !== lead; });
    var pinned = others.filter(function (x) { return x.pin > 0; });
    var free = others.filter(function (x) { return !(x.pin > 0); });
    var sorted = sortByRank(free, view, lead ? genderOf(lead.alt) : '');
    return placePins(lead, pinned, sorted);
  }

  /* Shopifys raekkefoelge praecis. Variantens billede ignoreres her.
     Kun pins flytter noget, og #1 er plads 1. */
  function manualOrder(items) {
    var pinned = items.filter(function (x) { return x.pin > 0; });
    if (!pinned.length) return items;
    var free = items.filter(function (x) { return !(x.pin > 0); });
    return placePins(null, pinned, free);
  }

  function parsePin(value) {
    var text = String(value == null ? '' : value).trim();
    if (!/^\d{1,2}$/.test(text)) return 0;
    var n = parseInt(text, 10);
    return n >= 1 && n <= MAX_PIN ? n : 0;
  }

  /* Test-krog, kun paa temaer der ikke er live:
     ?twrd_gallery=auto|manual  og  ?twrd_pins=<mediaId>:<plads>,... */
  function testHook() {
    var none = { order: '', pins: {} };
    try {
      var theme = window.Shopify && window.Shopify.theme;
      if (!theme || theme.role === 'main') return none;
      var params = new URLSearchParams(window.location.search);
      var order = String(params.get('twrd_gallery') || '').toLowerCase();
      var pins = {};
      String(params.get('twrd_pins') || '').split(',').forEach(function (pair) {
        var bits = pair.split(':');
        var pin = parsePin(bits[1]);
        if (bits[0] && pin) pins[bits[0].trim()] = pin;
      });
      return { order: ORDERS.indexOf(order) !== -1 ? order : '', pins: pins };
    } catch (err) {
      return none;
    }
  }

  var ORDERS = ['manual', 'auto'];
  var DEFAULT_ORDER = 'manual';

  /* Alt-teksten som den staar paa billedet (pin-markoeren er fjernet i Liquid). */
  function altOf(slide) {
    var img = slide.querySelector('img.media-gallery__image') || slide.querySelector('[data-twrd-alt]') || slide.querySelector('img[alt]');
    if (!img) return '';
    var text = img.getAttribute('data-twrd-alt') || img.getAttribute('alt') || '';
    return String(text).toLowerCase();
  }

  /* En video-flise (twrd-gallery-video.liquid) maa aldrig vaere slide 0:
     foerste flise er sidens LCP-billede. Staar en video forrest, bytter den
     plads med gruppens foerste billede. Resten af raekkefoelgen roeres ikke. */
  function isVideoSlide(slide) {
    return !!(slide && slide.classList && slide.classList.contains('media-gallery__wrapper--video'));
  }

  function imageFirst(keep, slides) {
    if (!keep.length || !isVideoSlide(slides[keep[0]])) return keep;
    for (var i = 1; i < keep.length; i++) {
      if (!isVideoSlide(slides[keep[i]])) {
        var out = keep.slice();
        out[0] = keep[i];
        out[i] = keep[0];
        return out;
      }
    }
    return keep;
  }

  function describe(slide, index, pins) {
    var mediaId = mediaIdOf(slide);
    return {
      index: index,
      alt: altOf(slide),
      view: viewOf(slide),
      mediaId: mediaId,
      pin: pins[mediaId] || parsePin(slide.getAttribute('data-twrd-pin'))
    };
  }

  /* Fjerner de medier der ikke hoerer til farven, og nummererer resten om,
     saa temaets slide-indeks, thumbnails og zoom-liste passer sammen. */
  function filter(node, colour, view, featuredId, mode) {
    var order = (mode && mode.order) || DEFAULT_ORDER;
    var pins = (mode && mode.pins) || {};
    var slides = Array.prototype.slice.call(node.querySelectorAll('[data-slide]'));
    var thumbList = node.querySelector('.js-media-gallery-thumb-list');
    var thumbs = thumbList ? Array.prototype.slice.call(thumbList.children) : [];

    var all = slides.map(function (_, index) {
      return index;
    });

    var keep = [];
    for (var i = 0; i < slides.length; i++) {
      if (matches(slides[i], colour)) keep.push(i);
    }
    /* Ingen billeder for farven: vis alle frem for ingenting. */
    if (!keep.length) keep = all.slice();
    /* Farvens billeder. Print-filteret nedenfor falder tilbage hertil,
       saa en tom print-kombination aldrig lukker farven ud. */
    var colourKeep = keep.slice();

    /* Style (FRONT PRINT / BACK PRINT):
       1. Medier maerket med en ANDEN edition (alt: "back print edition" /
          "front print edition") skjules.
       2. Findes der medier maerket med den valgte edition, vises KUN de.
       3. Ellers vises medierne uden edition. Raekkefoelgen roeres ikke. */
    if (view) {
      var own = [];
      var neutral = [];
      for (var k = 0; k < keep.length; k++) {
        var ed = editionOf(slides[keep[k]]);
        if (ed === view) own.push(keep[k]);
        else if (!ed) neutral.push(keep[k]);
      }
      keep = own.length ? own : neutral;
      /* Trappe-fallback: farvens billeder foerst, derefter alle.
         Galleriet maa aldrig ende tomt. */
      if (!keep.length) keep = colourKeep.slice();
      if (!keep.length) keep = all.slice();
    }

    /* RAEKKEFOELGE. keep er her i Shopifys raekkefoelge.
       manual: Shopifys raekkefoelge praecis. Variantens billede ignoreres.
               Kun pins flytter noget.
       auto:   sorteres efter billedtype, variantens billede forrest.
       Slide 0 er ALTID landingsbilledet: data-initial-slide er 0, og
       twrd-gallery-mobile.js stiller Swiper paa 0. I manual er temaets
       goToSlide(featured media) slaaet fra i render(), ellers ville et
       stoerrelsesvalg flytte karrusellen til variantens billede. */
    var ranks = {};
    var items = keep.map(function (index) {
      return describe(slides[index], index, pins);
    });
    if (order === 'auto') {
      items.forEach(function (item) {
        ranks[item.index] = rankOf(item.alt, item.view, view);
      });
      keep = autoOrder(items, view, featuredId).map(function (item) {
        return item.index;
      });
    } else {
      keep = manualOrder(items).map(function (item) {
        return item.index;
      });
    }
    keep = imageFirst(keep, slides);

    var carousel = node.querySelector('media-carousel');

    for (var r = 0; r < slides.length; r++) {
      if (keep.indexOf(r) !== -1) continue;
      if (slides[r].parentNode) slides[r].parentNode.removeChild(slides[r]);
      if (thumbs[r] && thumbs[r].parentNode) thumbs[r].parentNode.removeChild(thumbs[r]);
    }

    var slideIndex = 0;
    var imageIndex = 0;
    for (var ki = 0; ki < keep.length; ki++) {
      var s = keep[ki];
      /* appendChild flytter noden bagerst, saa keep-raekkefoelgen bliver DOM-raekkefoelgen. */
      if (slides[s].parentNode) slides[s].parentNode.appendChild(slides[s]);
      if (thumbs[s] && thumbs[s].parentNode) thumbs[s].parentNode.appendChild(thumbs[s]);

      /* Billedtypen til mosaikken (twrd-gallery-grid.js): udsnit og
         naerbilleder maa ikke blive den store flise. Kun i auto. */
      if (order === 'auto') {
        slides[s].setAttribute('data-twrd-tile', TILE_NAMES[ranks[s]] || 'pose');
        if (ranks[s] >= RANK_NO_WIDE) slides[s].setAttribute('data-twrd-nowide', '');
      }
      /* De foerste fliser er synlige med det samme: hent dem uden lazy. */
      if (slideIndex < EAGER_TILES) {
        var firstImg = slides[s].querySelector('img.media-gallery__image');
        if (firstImg && firstImg.getAttribute('loading') === 'lazy') firstImg.setAttribute('loading', 'eager');
      }

      var item = slides[s].querySelector('[data-slide-id]');
      if (item) item.setAttribute('data-slide-id', String(slideIndex));
      var link = slides[s].querySelector('.media-gallery__link');
      if (link) {
        link.setAttribute('data-slide-id', String(slideIndex));
        if (item) item.setAttribute('data-image-slide-index', String(imageIndex));
        imageIndex += 1;
      } else if (item && item.hasAttribute('data-image-slide-index')) {
        item.setAttribute('data-image-slide-index', String(imageIndex));
        imageIndex += 1;
      }

      var button = thumbs[s] ? thumbs[s].querySelector('.thumbnail') : null;
      if (button) button.setAttribute('data-slide-number', String(slideIndex));

      slideIndex += 1;
    }

    /* Altid 0: efter reglen ovenfor ER slide 0 landingsbilledet. */
    if (carousel) carousel.setAttribute('data-initial-slide', '0');
    node.setAttribute('data-twrd-vg-order', order);
    return slideIndex;
  }

  /* Performance (2026-10-23, C2): a cheap fingerprint of everything filter()
     decides. Two galleries with the same fingerprint show the same slides in
     the same order with the same numbering, so swapping one for the other
     changes nothing on screen. Theme JS state (Swiper classes, inline
     styles) is not part of it on purpose. */
  function signature(node) {
    var parts = [node.getAttribute('data-twrd-vg-order') || ''];
    var carousel = node.querySelector('media-carousel');
    parts.push('i' + (carousel ? carousel.getAttribute('data-initial-slide') || '' : '-'));
    var slides = node.querySelectorAll('[data-slide]');
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var item = slide.querySelector('[data-slide-id]');
      var link = slide.querySelector('.media-gallery__link');
      parts.push([
        mediaIdOf(slide),
        isVideoSlide(slide) ? 'v' : '',
        item ? item.getAttribute('data-slide-id') || '' : '-',
        item ? item.getAttribute('data-image-slide-index') || '' : '-',
        link ? link.getAttribute('data-slide-id') || '' : '-',
        slide.getAttribute('data-twrd-tile') || '',
        slide.hasAttribute('data-twrd-nowide') ? 'n' : ''
      ].join(':'));
    }
    var thumbList = node.querySelector('.js-media-gallery-thumb-list');
    var thumbs = thumbList ? thumbList.children : [];
    parts.push('t' + thumbs.length);
    for (var t = 0; t < thumbs.length; t++) {
      var button = thumbs[t].querySelector('.thumbnail');
      var thumbMedia = thumbs[t].querySelector('[data-media-id]');
      parts.push((button ? button.getAttribute('data-slide-number') || '' : '-') + ':' +
        (thumbMedia ? thumbMedia.getAttribute('data-media-id') || '' : ''));
    }
    return parts.join('|');
  }

  /* The parts of filter() that are safe to apply to the live gallery in
     place: the first tiles load eagerly, exactly as on a swapped node. */
  function eagerFirstTiles(node) {
    var slides = node.querySelectorAll('[data-slide]');
    for (var i = 0; i < slides.length && i < EAGER_TILES; i++) {
      var img = slides[i].querySelector('img.media-gallery__image');
      if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    }
  }

  function render(ctx, colour, view, featuredId) {
    var key = colour + '|' + (view || '') + '|' + (featuredId || '');
    if (!colour || key === ctx.current) return;
    var host = document.createElement('div');
    host.innerHTML = ctx.template;
    var next = host.firstElementChild;
    if (!next) return;

    filter(next, colour, view, featuredId, { order: ctx.order, pins: ctx.pins });
    next.__twrdVg = ctx;
    /* manual: galleriet aabner paa gruppens foerste billede fra Admin, ikke
       paa variantens billede. Temaet (product-single.js) kalder
       goToSlide(featured media) ved hvert variantskift, ogsaa ved et
       stoerrelsesvalg. Kaldet goeres tomt paa denne node. auto har variantens
       billede paa slide 0, saa der er kaldet ufarligt. */
    if (ctx.order !== 'auto') next.goToSlide = function () {};

    if (!ctx.node.parentNode) return;

    /* Performance (2026-10-23, C2): the filtered gallery is identical to the
       one on screen (page load of a one-colour product, or a size-only
       change). Keep the live node: the LCP image, Swiper and PhotoSwipe stay
       as they are. Only the in-place bits of a swap are applied. No
       rendered event: nothing was rebuilt, so nothing needs to rebind. */
    if (signature(next) === signature(ctx.node)) {
      if (ctx.order !== 'auto') ctx.node.goToSlide = function () {};
      eagerFirstTiles(ctx.node);
      ctx.current = key;
      return;
    }
    ctx.node.parentNode.replaceChild(next, ctx.node);
    ctx.node = next;
    ctx.current = key;

    document.dispatchEvent(
      new CustomEvent('twrd:variant-gallery:rendered', { detail: { gallery: next, colour: colour } })
    );
  }

  function sync(ctx) {
    render(ctx, selectedColour(ctx), selectedView(ctx), featuredMediaId(ctx));
  }

  function orderOf(gallery) {
    var value = clean(gallery.getAttribute('data-twrd-vg-order')).toLowerCase();
    return ORDERS.indexOf(value) !== -1 ? value : DEFAULT_ORDER;
  }

  function clean(value) {
    return String(value || '').replace(/^["'\s]+|["'\s]+$/g, '');
  }

  function setup(gallery) {
    if (!gallery || gallery.__twrdVg) return;
    var colours = clean(gallery.getAttribute('data-twrd-vg-colours'))
      .split('|')
      .map(function (value) {
        return value.trim().toLowerCase();
      })
      .filter(Boolean);
    if (!colours.length) return;

    var hook = testHook();
    var ctx = {
      node: gallery,
      template: gallery.outerHTML,
      colours: colours,
      optName: clean(gallery.getAttribute('data-twrd-vg-option')) || 'Color',
      featured: featuredMap(gallery),
      order: hook.order || orderOf(gallery),
      pins: hook.pins,
      scope: gallery.closest('.section--product-single') || document,
      current: null
    };
    gallery.__twrdVg = ctx;

    var schedule = function () {
      window.setTimeout(function () {
        sync(ctx);
      }, 60);
    };

    ctx.scope.addEventListener('change', function (e) {
      var name = (e.target && e.target.getAttribute && e.target.getAttribute('name')) || '';
      var lower = name.toLowerCase();
      if (lower === ctx.optName.toLowerCase() || isStyleName(lower)) schedule();
    });
    ctx.scope.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form__swatch__label')) {
        window.setTimeout(function () {
          sync(ctx);
        }, 60);
      }
    });
    var selects = ctx.scope.querySelectorAll(
      'variant-selects, variant-radios, variant-swatches, variant-mixed-inputs'
    );
    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('on:variant:change', schedule);
    }
    document.addEventListener('on:variant:change', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('variant:changed', schedule);

    sync(ctx);
  }

  /* Rene funktioner, laest af scripts/tests/test_gallery_order.mjs. */
  window.TWRD_GALLERY_ORDER = {
    rankOf: rankOf,
    autoOrder: autoOrder,
    manualOrder: manualOrder,
    placePins: placePins,
    parsePin: parsePin,
    tileNames: TILE_NAMES,
    signature: signature
  };

  function init() {
    var galleries = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < galleries.length; i++) setup(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
